import { consts } from '../actions/verifyActions'

const INIT = {
  error: null,
  email: {
    isPending: false,
    status: null,
    message: null,
  }
  
};

export default function reducer(state=INIT, action) {
    switch (action.type) {

    case consts.VERIFY_PENDING: {
        state = Object.assign({}, state, { isPending: true, error: null, email: { isPending: true, statusCode: null, message: null } });
        break;
    }
    case consts.VERIFY_RESOLVE: {
        state = Object.assign({}, state, { isPending: false, error: null, email: { isPending: false, status: action.data.statusCode, message: action.data.message } });
        break;
    }
    case consts.VERIFY_REJECT: {
        state = Object.assign({}, state, { isPending: false, error: action.error, email: { isPending: false, statusCode: false, message: action.error } });
        break;
    }

      case consts.VERIFY_RESET: {
          return INIT;
          break;
      }
      
    };
    return state;
}



// WEBPACK FOOTER //
// ./src/store/reducers/verifyReducer.js